import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M29.47 11.12l-13-7a1 1 0 00-.94 0l-13 7a1 1 0 10.94 1.76L5 12.06V26a2 2 0 002 2h18a2 2 0 002-2V12.06l1.53.82a1 1 0 10.94-1.76zM25 11v15H7V11l9-4.84L25 11z"/><path d="M22 16a1 1 0 01-1 1H11a1 1 0 010-2h10a1 1 0 011 1zM22 20a1 1 0 01-1 1H11a1 1 0 010-2h10a1 1 0 011 1z"/>';
export var EqualHousingOutlineSVG = function EqualHousingOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
EqualHousingOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(EqualHousingOutlineSVG);